/* MKPBR 20/10/2026 - HOME LEVE (varejo). A home chega mais leve: alguns blocos vem "vazios" (cartoes cinza) e o
   conteudo de verdade chega logo depois, pedido a Shopify em paralelo pela Section Rendering API:
     <mesma URL>?section_id=<secao>&page=2   (o Liquid da secao monta a versao completa quando current_page == 2)
   Os pedidos ja foram disparados por um script curto no templates/index.liquid (window.MKLEVE); aqui cada resposta
   entra no lugar: cada elemento [data-mk-fill="chave"] da secao recebe o conteudo do elemento com a mesma chave
   na resposta. Os botoes, setas e abas continuam os mesmos (so o recheio muda), entao nada precisa ser religado.
   Se a Shopify falhar, tenta de novo (3 vezes). Se nao der: some o cinza (fica o titulo e o link "ver todos"). */
(function () {
  'use strict';
  var d = document;
  var P = window.MKLEVE || {};
  function busca(id) {
    var u = new URL(location.href);
    u.searchParams.set('section_id', id);
    u.searchParams.set('page', '2');
    u.hash = '';
    return fetch(u.toString(), { credentials: 'same-origin', headers: { Accept: 'text/html' } }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.text();
    });
  }
  function pede(pr, id, tent) {
    return pr.then(function (html) {
      if (html.indexOf('shopify-section-' + id) < 0) throw new Error('sem secao');
      return html;
    }).catch(function () {
      if (tent >= 3) throw new Error('falhou');
      return new Promise(function (ok) { setTimeout(ok, 700 * (tent + 1)); }).then(function () { return pede(busca(id), id, tent + 1); });
    });
  }
  function trilhos(el) {
    /* avisa as setas dos carrosseis (mkpbr-h26-home.js) que o conteudo mudou */
    [].forEach.call(el.querySelectorAll('.rail__track'), function (t) {
      try { t.dispatchEvent(new Event('scroll')); } catch (e) {}
    });
  }
  function entra(sec, html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var alvos = [].slice.call(sec.querySelectorAll('[data-mk-fill]'));
    var achou = 0;
    alvos.forEach(function (a) {
      var k = a.getAttribute('data-mk-fill');
      var novo = doc.querySelector('[data-mk-fill="' + k + '"]');
      if (!novo) return;
      achou++;
      var frag = d.createDocumentFragment();
      while (novo.firstChild) frag.appendChild(d.adoptNode(novo.firstChild));
      a.textContent = '';
      a.appendChild(frag);
      a.removeAttribute('aria-busy');
    });
    /* secao que nao tem nada na versao completa (ex.: colecao vazia): sai da pagina */
    if (!achou && alvos.length) { var w = sec.closest('.shopify-section') || sec; w.parentNode && w.parentNode.removeChild(w); return; }
    sec.removeAttribute('data-mk-leve');
    trilhos(sec);
    try { if (window.MKFS && window.MKFS.scan) window.MKFS.scan(sec); } catch (e) {}
  }
  function desiste(sec) {
    /* sem a resposta: tira os cartoes cinza; o titulo e o link "ver todos" continuam */
    [].forEach.call(sec.querySelectorAll('.mksk, .mksk-t'), function (s) { s.parentNode && s.parentNode.removeChild(s); });
    sec.removeAttribute('data-mk-leve');
    trilhos(sec);
  }
  [].forEach.call(d.querySelectorAll('[data-mk-leve]'), function (sec) {
    var id = sec.getAttribute('data-mk-leve');
    pede(P[id] || busca(id), id, 0)
      .then(function (html) { entra(sec, html); })
      .catch(function () { desiste(sec); });
  });
})();
